import Post from './post.js';
import Style from './style.js';
import { __ } from '@wordpress/i18n';
import {InspectorControls} from '@wordpress/block-editor';
import {VayuBlocksAdvancePanel} from '@vayu-blocks/advance-panel';
import {VayuBlocksHeaderTab, usePanelSettings} from '@vayu-blocks';

const panelKeys = [
	'settings-layout',
	'settings-controls',
	'settings-filter',
	'settings-pagination',
	
	'Style-layout',
	'Style-content',
	'Style-title',
	'Style-excerpt',
	'Style-category',
	'Style-tags',
	'Style-meta',
];

const initialPanels = {
	Settings: 'settings-layout',
	Style: '',
	advanced: '',
};

const panelOptions = [
	{label: __( 'Setting', 'vayu-blocks' ), value: 'setting', icon: 'colorwand' },
	{label: __( 'Style', 'vayu-blocks' ), value: 'style', icon: 'diamond'},
	{label: __( 'Advanced', 'vayu-blocks' ), value: 'advanced', icon: 'colorpalette'}
];

const PanelSettings = ({attributes,setAttributes,isSelected,clientId }) => {

	const { tab, setTab, openPanels, onTogglePanel } = usePanelSettings({ clientId, panelKeys, initialPanels, defaultTab: 'setting' });

	const tabComponents = {
		setting: <Post attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
		style: <Style attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
		advanced: <VayuBlocksAdvancePanel attributes={attributes} setAttributes={setAttributes} clientId={clientId} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
	};
	
    return (
		<>
			{isSelected && (
				<InspectorControls>
					<div className='th-block-ins th-button-panel'>
						<VayuBlocksHeaderTab 
							value={ tab }
							options={panelOptions}
							onChange={ setTab }
						/>

						{tabComponents[tab]}
					</div>
				</InspectorControls>  
			)}

    	</>
	);
}

export default PanelSettings;